import { query } from './api-consumer';

export default {
  async getDomainIdentityProvider(domain) {
    return query('getDomainIdentityProvider', { domain });
  },
};
